import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";
import { emptyRenovationListing } from "../models/renovationListingModel";

import { publishRenovationListing }
  from "../services/publishRenovationListing";

import StepRenovationType
  from "../components/addRenovation/StepRenovationType";
import StepRenovationDetails from "../components/addRenovation/StepRenovationDetails";

import StepRenovationAvailability
  from "../components/addRenovation/StepRenovationAvailability";

import StepRenovationPhotosDescription
  from "../components/addRenovation/StepRenovationPhotosDescription";

export default function AddRenovationListing() {

  const navigate = useNavigate();
  const { t } = useTranslation();
const { user } = useAuth();
  const [step, setStep] = useState(1);

const [submitting, setSubmitting] = useState(false);

  const [listing, setListing] = useState({
    ...emptyRenovationListing,
  });

const handleSubmit = async () => {
  if (submitting) return;

  await publishRenovationListing({
    listing,
    user, // we'll replace this with AuthContext
    submitting,
    setSubmitting,
    navigate,
    t,
  });
};

  return (
    <div className="add-listing">

      {/* STEP 1 */}

      {step === 1 && (
        <StepRenovationType
          listing={listing}
          setListing={setListing}
          onNext={() => setStep(2)}
        />
      )}



      {step === 2 && (
  <StepRenovationDetails
    listing={listing}
    setListing={setListing}
    onBack={() => setStep(1)}
    onNext={() => setStep(3)}
      />
    )}

{step === 3 && (
  <StepRenovationAvailability
    listing={listing}
    setListing={setListing}
    onBack={() => setStep(2)}
    onNext={() => setStep(4)}
  />
)}

{step === 4 && (
  <StepRenovationPhotosDescription
    listing={listing}
    setListing={setListing}
    onBack={() => setStep(3)}
    onSubmit={handleSubmit}
    submitting={submitting}
  />
)}

    </div>
  );
}
